import type { Feature } from '@luna/gatekeeper';

export const creditCardLimitChange: Feature = {
    enabled: true,
    _description:
        'Displays credit card limit change in credit card features page and supplementary settings page - supported by AT only',
};
